<template>
  <div class="mx-auto properties-view-card">
    <artifact-properties
      v-if="currentArtifact || currentArtifactType"
      id="propertiesView"
      :style="`height: ${height}px;`"
      :current-artifact="currentArtifact"
      :current-artifact-type="currentArtifactType"
    />
    <v-container v-else id="propertiesView" class="property-title" :style="`height: ${height}px;`">
      {{ labels.PROPERTIES_VIEW.NO_PROPERTIES_AVAILABLE }}
    </v-container>
  </div>
</template>

<script lang="ts" setup>
  import ArtifactProperties from './ArtifactProperties.vue'
  import { Artifact, ArtifactType, Snapshot } from '@/models'
  import { EventBus } from '@/event-bus'
  import { computed, ref, watch } from 'vue'
  import { useSnapshotStore } from '@/stores/snapshotStore'
  import labels from '@/translations/labels.json'
  const props = defineProps({
    height: { type: Number, required: true },
  })
  const currentArtifact = ref<Artifact>()
  const currentArtifactType = ref<ArtifactType>()
  const snapshotStore = useSnapshotStore()

  EventBus.on('updatePropertiesArtifact', setArtifact)
  EventBus.on('updatePropertiesArtifactType', setArtifactType)

  const currentSnapshot = computed((): Snapshot | undefined => {
    return snapshotStore.currentSnapshot
  })

  const height = computed((): number => {
    return props.height
  })

  watch(currentSnapshot, () => {
    currentArtifact.value = undefined
    currentArtifactType.value = undefined
  })

  function setArtifact(artifact: Artifact): void {
    currentArtifact.value = artifact
    currentArtifactType.value = undefined
  }

  function setArtifactType(artifactType: ArtifactType): void {
    currentArtifactType.value = artifactType
    currentArtifact.value = undefined
  }
</script>

<style lang="scss" scoped>
  .properties-container {
    position: absolute;
    top: 200px;
    left: 45em;
    width: 300px;
    height: 300px;
    resize: none;
    overflow: hidden;
    border: 0px;
    z-index: 2;
    min-width: 150px;
    min-height: 35px;
  }

  .properties-view-card {
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
    overflow: auto;
  }
  #propertiesView {
    overflow-y: hidden;
    transition: height 0.2s ease-in-out;
  }
</style>

<style src="./../SearchView.scss" lang="scss" scoped />
